var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex flex-col gap-3"},[_c(_setup.SingleSignOnApple,{attrs:{"mode":_vm.mode}}),_vm._v(" "),_c(_setup.SingleSignOnFacebook,{attrs:{"mode":_vm.mode}}),_vm._v(" "),_c(_setup.SingleSignOnGoogle,{attrs:{"mode":_vm.mode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }